"use client";
import useRouteChange from "@stadium/hooks/lib/use-route-change";
import { useCallback, useEffect, useState } from "react";
import ReactGA4 from "react-ga4";

export const gtagEvent = (eventName, dynamicFields = {}) => {
  const { gtag } = window;
  if (typeof gtag === "function") {
    gtag("event", eventName, { ...dynamicFields });
  }
};

export const userIdTracker = (userId) => {
  ReactGA4.set({ userId });
};

const useGA4Analytics = (id) => {
  const [analyticsInitialised, setAnalyticsInitialised] = useState(false);

  const pageViewEvent = useCallback((url) => {
    ReactGA4.send({ hitType: "pageview", page: url });
  }, []);

  useRouteChange(pageViewEvent);

  useEffect(() => {
    if (!analyticsInitialised) {
      if (id) {
        ReactGA4.initialize(id);
        setAnalyticsInitialised(true);
      }

    }
  }, [analyticsInitialised, id]);
};

export default useGA4Analytics;
